import { render, staticRenderFns } from "./budget.vue?vue&type=template&id=5e34634f&scoped=true"
import script from "./budget.vue?vue&type=script&lang=js"
export * from "./budget.vue?vue&type=script&lang=js"
import style0 from "./budget.vue?vue&type=style&index=0&id=5e34634f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e34634f",
  null
  
)

export default component.exports